import styled from "styled-components";

export const IntegrationTableContainer = styled.div`
    width: 100%;
    min-height: 60vh;
    margin: 0;
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    /* Tablet ve küçük ekranlar için */
    @media (max-width: 768px) {
        padding: 16px;
        border-radius: 8px;
    }

    /* Mobil ekranlar için */
    @media (max-width: 480px) {
        padding: 12px;
        border-radius: 6px;
        margin: 0 -8px; /* Kenar boşluklarını azalt */
    }

    /* Çok küçük ekranlar için */
    @media (max-width: 320px) {
        padding: 8px;
        margin: 0 -4px;
    }
`;

export const IntegrationsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, 240px);
    gap: 12px;
    max-width: 100%;
    margin: 0;

    @media (max-width: 768px) {
        grid-template-columns: repeat(auto-fit, 160px);
        gap: 10px;
    }

    @media (max-width: 480px) {
        grid-template-columns: repeat(auto-fit, 140px);
        gap: 8px;
    }

    @media (max-width: 320px) {
        grid-template-columns: repeat(auto-fit, 120px);
        gap: 6px;
    }
`;

export const IntegrationBox = styled.div`
    padding: 8px;
    border: 2px solid #aef001;
    border-radius: 8px;
    background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    aspect-ratio: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
        transition: left 0.6s ease;
    }

    &:hover {
        transform: translateY(-4px) scale(1.05);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
        border-color: ${props => props.platformColor || "#aef001"};
        &::before {
            left: 100%;
        }
    }

    &:active {
        transform: translateY(-2px) scale(1.02);
        transition: all 0.1s ease;
    }

    /* Tablet ve küçük ekranlar için */
    @media (max-width: 768px) {
        padding: 6px;
    }

    /* Mobil ekranlar için */
    @media (max-width: 480px) {
        padding: 4px;

        &:hover {
            transform: translateY(-2px) scale(1.03);
        }
    }

    /* Çok küçük ekranlar için */
    @media (max-width: 320px) {
        padding: 3px;
    }
`;

export const IntegrationText = styled.span`
    font-size: 20px;
    color: ${props => props.platformColor};
    font-weight: 600;
    transition: all 0.3s ease;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    text-align: center;
    word-break: break-word;
    line-height: 1.2;

    ${IntegrationBox}:hover & {
        transform: translateY(-1px);
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    /* Tablet ve küçük ekranlar için */
    @media (max-width: 768px) {
        font-size: 12px;
    }

    /* Mobil ekranlar için */
    @media (max-width: 480px) {
        font-size: 11px;
    }

    /* Çok küçük ekranlar için */
    @media (max-width: 320px) {
        font-size: 10px;
    }
`;

export const EmptyStateContainer = styled.div`
    padding: 40px 24px;
    text-align: center;
    background-color: #fafafa;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    width: 100%;

    /* Tablet ve küçük ekranlar için */
    @media (max-width: 768px) {
        padding: 32px 20px;
        border-radius: 8px;
    }

    /* Mobil ekranlar için */
    @media (max-width: 480px) {
        padding: 24px 16px;
        border-radius: 6px;
    }

    /* Çok küçük ekranlar için */
    @media (max-width: 320px) {
        padding: 20px 12px;
    }
`;

export const EmptyStateIcon = styled.div`
    font-size: 48px;
    color: #d9d9d9;
    margin-bottom: 16px;

    /* Tablet ve küçük ekranlar için */
    @media (max-width: 768px) {
        font-size: 40px;
        margin-bottom: 12px;
    }

    /* Mobil ekranlar için */
    @media (max-width: 480px) {
        font-size: 32px;
        margin-bottom: 8px;
    }

    /* Çok küçük ekranlar için */
    @media (max-width: 320px) {
        font-size: 24px;
        margin-bottom: 6px;
    }
`;

export const SectionTitle = styled.div`
    margin-bottom: 12px;
`;

export const IntegrationLinkContainer = styled.div`
    margin-top: 8px;
    font-size: 12px;
    color: #666;
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const ExternalLinkOutlined = styled.img`
    width: 14px;
    height: 14px;
    color: #666;
    src: ${props => props.src};
`;
